<template>
  <div>
    <v-card v-if="!year_available" :disabled="true">
      <v-card-text>
        currently not availble.
      </v-card-text>
    </v-card>
    <div
      v-if="year_available"
    >
      <div class="search-container pa-2 pa-md-5">
        <div class="white--text text-center pb-3">
          <h3>{{ $t("explore.find_open_curriculum") }}</h3>
        </div>

        <v-card>
          <v-card-text>
            <v-row>
              <v-col class="col-12 col-md-6 col-xl-4">
                <h4>{{ $t("explore.select_faculty_to_search") }}</h4>
                <v-autocomplete
                  chips
                  clearable
                  dense
                  deletable-chips
                  multiple
                  outlined
                  :items="available_faculties"
                  v-model="falultiesSelected"
                  :item-text="(item) => objectTranslator(item, 'FACULTY_NAME')"
                  :item-value="(item) => item.MASTER_REG_FACULTY_ID"
                  hide-details
                >
                </v-autocomplete>
              </v-col>

              <v-col class="col-12 col-md-6 col-xl-4">
                <h4>{{ $t("explore.select_round_to_search") }}</h4>
                <v-autocomplete
                  v-model="roundsSelected"
                  :items="available_rounds"
                  multiple
                  outlined
                  chips
                  clearable
                  dense
                  deletable-chips
                  :item-text="
                    (item) =>
                      ' ( ' +
                      item.SEMESTER +
                      '/' +
                      item.YEAR +
                      ' ) ' +
                      $t('explore.round') +
                      ' ' +
                      item.ROUND_NUMBER +
                      ' - ' +
                      objectTranslator(item, 'ROUND_NAME')
                  "
                  :item-value="(item) => item.ROUND_ID"
                  hide-details
                >
                </v-autocomplete>
              </v-col>

              <v-col class="col-12 col-md-6 col-xl-4">
                <h4>{{ $t("explore.select_project_to_search") }}</h4>
                <v-autocomplete
                  v-model="projectSelected"
                  :items="available_projects"
                  multiple
                  outlined
                  chips
                  clearable
                  dense
                  deletable-chips
                  :item-text="(item) => objectTranslator(item, 'PROJECT_NAME')"
                  :item-value="(item) => item.PROJECT_ID"
                  hide-details
                >
                </v-autocomplete>
              </v-col>
              <v-col class="col-12 col-md-6 col-xl-4">
                <h4>{{ $t("explore.select_inter_to_search") }}</h4>
                <v-autocomplete
                  v-model="interSelected"
                  :items="inter_choices"
                  multiple
                  outlined
                  chips
                  clearable
                  dense
                  deletable-chips
                  :item-text="(item) => objectTranslator(item, 'NAME')"
                  :item-value="(item) => item.isInter"
                  hide-details
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <h4>
                  {{ $t("explore.more_search_words") }}
                </h4>
                <v-combobox
                  chips
                  clearable
                  dense
                  deletable-chips
                  multiple
                  outlined
                  v-model="keywords"
                  hide-details
                >
                  <template v-slot:item="data">
                    {{ data.item.name_en }}
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
      <div class="">
        <ProgramList
          ref="programlist"
          :curriculums="filterd_curriculums"
          :open_confirm_regis_dialog="open_confirm_regis_dialog"
        />
      </div>
    </div>

    <ConfirmRegisDialog
      ref="confirmRegisDialog"
      :curriculums="curriculums"
      v-model="confirm_regis_dialog_status"
      v-if="isApplicantLoggedIn"
    />

    <Popup v-if="show_popup" />
  </div>
</template>

<script>
import ProgramList from "@/components/explore_page/ProgramList";
import GenericProvider from "@/services/generic.provider";
import { uniq_by_prop } from "@/helper/array";
import { objectTranslator } from "@/helper/translator";
import { includeString } from "@/helper/filter";
import ConfirmRegisDialog from "@/components/structures/ConfirmRegisDialog";
import Popup from "@/components/etc/Popup";

const genericService = new GenericProvider();

// const LEVEL_UNDERGRAD_PROP_TEXT = "undergraduate";

export default {
  name: "Explore",
  components: {
    ProgramList,
    ConfirmRegisDialog,
    Popup,
  },
  props: {
    level: Number,
    update_year_text: Function,
  },
  data: () => ({
    year_available: true,
    year_data: null,
    curriculums: [],

    falultiesSelected: [],
    roundsSelected: [],
    projectSelected: [],
    keywords: [],
    interSelected: [],

    confirm_regis_dialog_status: false,

    inter_choices: [
      {
        NAME_EN: "International Program",
        NAME_TH: "หลักสูตรนานาชาติ",
        isInter: true,
      },
      { NAME_EN: "Thai Program", NAME_TH: "หลักสูตรไทย", isInter: false },
    ],
  }),
  computed: {
    isApplicantLoggedIn() {
      return (
        this.$store.state.auth.user &&
        this.$store.state.auth.user.admission.status
      );
    },
    filterd_curriculums() {
      let ret = this.curriculums;
      if (this.falultiesSelected.length !== 0) {
        ret = ret.filter((item) =>
          this.falultiesSelected.includes(item.MASTER_REG_FACULTY_ID)
        );
      }

      if (this.interSelected.length !== 0) {
        ret = ret.filter(
          (item) =>
            (this.interSelected.includes(true) &&
              item.INTER === "1") ||
            (this.interSelected.includes(false) &&
              item.INTER === "0")
        );
      }

      if (this.roundsSelected.length !== 0) {
        ret = ret.filter((item) => this.roundsSelected.includes(item.ROUND_ID));
      }

      if (this.projectSelected.length !== 0) {
        ret = ret.filter((item) =>
          this.projectSelected.includes(item.PROJECT_ID)
        );
      }

      if (this.keywords.length !== 0) {
        ret = ret.filter((item) =>
          this.keywords.reduce((result, keyword) => {
            return (
              includeString(item.FACULTY_NAME_EN, keyword) ||
              includeString(item.FACULTY_NAME_TH, keyword) ||
              includeString(item.CURRICULUM_SHORT_NAME_EN, keyword) ||
              includeString(item.CURRICULUM_SHORT_NAME_TH, keyword) ||
              includeString(item.CURRICULUM_FULL_NAME_EN, keyword) ||
              includeString(item.CURRICULUM_FULL_NAME_TH, keyword) ||
              includeString(item.BRANCH_NAME_EN, keyword) ||
              includeString(item.BRANCH_NAME_TH, keyword) ||
              includeString(item.STUDY_PLAN_NAME_TH, keyword) ||
              includeString(item.STUDY_PLAN_NAME_EN, keyword) ||
              result
            );
          }, false)
        );
      }
      if (this.$refs.programlist) {
        this.$refs.programlist.reset_pagination();
      }
      return ret;
    },

    available_faculties() {
      const uniqueById = uniq_by_prop("MASTER_REG_FACULTY_ID");
      const ret = uniqueById(this.curriculums);
      return ret.map((item) => ({
        MASTER_REG_FACULTY_ID: item.MASTER_REG_FACULTY_ID,
        MASTER_REG_CURRICULUM_ID: item.MASTER_REG_CURRICULUM_ID,
        FACULTY_NAME_TH: item.FACULTY_NAME_TH,
        FACULTY_NAME_EN: item.FACULTY_NAME_EN,
      }));
    },
    available_rounds() {
      const uniqueById = uniq_by_prop("ROUND_ID");
      const ret = uniqueById(this.curriculums);
      return ret.map((item) => ({
        ROUND_ID: item.ROUND_ID,
        ROUND_NUMBER: item.ROUND_NUMBER,
        ROUND_NAME_EN: item.ROUND_NAME_EN,
        ROUND_NAME_TH: item.ROUND_NAME_TH,
        YEAR: item.YEAR,
        SEMESTER: item.SEMESTER,
      }));
    },
    available_projects() {
      const uniqueById = uniq_by_prop("PROJECT_ID");
      const ret = uniqueById(this.curriculums);
      return ret.map((item) => ({
        PROJECT_ID: item.PROJECT_ID,
        PROJECT_NAME_EN: item.PROJECT_NAME_EN,
        PROJECT_NAME_TH: item.PROJECT_NAME_TH,
        YEAR: item.YEAR,
        SEMESTER: item.SEMESTER,
      }));
    },

    show_popup() {
      if (this.roundsSelected.includes("98")) return true;
      return false;
    },
  },
  methods: {
    objectTranslator,

    async fetch_data() {
      const year_data = await genericService
        .getCurrentYear(this.level)
        .catch(() => {
          this.year_available = false;
        });
      if (year_data) {
        this.year_available = true;
        this.year_data = year_data;
        this.update_year_text(
          this.level,
          year_data.SEMESTER + " / " + year_data.YEAR
        );

        const data = await genericService.getFilteredCurriculumsForStudentByLevelId(
          this.level
        );
        this.curriculums = data;
      }
    },

    open_confirm_regis_dialog(curriculum_object) {
      this.$refs.confirmRegisDialog.prepareDataBeforeOpenDialog(
        curriculum_object
      );
      this.confirm_regis_dialog_status = true;
    },
  },
  created() {
    this.fetch_data();
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  background-color: #0005;
}
</style>
